import { Invite } from "../dtos/invite.model";
import { apiRequest } from "../auth/api-request";
import { ApiResponse } from "../dtos/api-respone.model";

export class InviteService {
  static getOne(inviteId: string): Promise<Invite> {
    return apiRequest
      .get<ApiResponse<Invite>>(`invite/${inviteId}`)
      .then((o) => new Invite(o.data.data));
  }

  static getPending(): Promise<Invite | null> {
    return apiRequest
      .get<ApiResponse<Invite | null>>(`invite/pending`)
      .then((o) => (o.data.data ? new Invite(o.data.data) : null));
  }
}
